import { render } from "./VerPost.vue?vue&type=template&id=5741cdf7"
import script from "./VerPost.vue?vue&type=script&lang=js"
export * from "./VerPost.vue?vue&type=script&lang=js"

import "./VerPost.vue?vue&type=style&index=0&id=5741cdf7&lang=css"

import exportComponent from "/var/www/html/genesis-git/vue-genesis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__